// USA
import MENU from "./Layout/menu_ar"
import Old from "./old_ar"
export const locale = {
  ...MENU,
  ...Old
};
